import Axios from "axios"
import jwtDecode from "jwt-decode"

export const Logger = {
  info(msg, alert) {
    this.execute(msg, alert, "INFO")
    console.log(msg)
  },
  debug(msg, alert) {
    this.execute(msg, alert, "DEBUG")
    console.debug(msg)
  },
  error(msg, alert, stack) {
    this.execute(msg, alert, "ERROR", stack)
    console.error(msg)
  },
  warn(msg, alert) {
    this.execute(msg, alert, "WARN")
    console.debug(msg)
  },

  execute(msg, alert, level,stack) {
    const tunnelData = localStorage.getItem('tunnelData')?JSON.parse(localStorage.getItem('tunnelData')):undefined;

    const token = sessionStorage.getItem("user_token") && jwtDecode(
      sessionStorage.getItem("user_token"))
    Axios.post("/api/v1/send-log-notification",
      {message: msg, isAlert: alert, level: level,stack:stack},
      {
        headers: {
          'opl': tunnelData.opl,
          'actual_page': tunnelData.step,
          'ip': tunnelData.clientIpAddressHeader,
          'user': token ? token.username : 'client'
        }
      }).then()
  }
};

